import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { formatXml, prepareSoapOperationRequest } from 'src/app/_services/soap/roller-api-operations';
import { DispatchBranchOption } from './dispatch-planner-team.service';

export interface RollerSoapImportDialogData {
  branchNo?: string;
  terminDate?: string;
  branches?: DispatchBranchOption[];
}

export interface RollerSoapImportDialogResult {
  branchNo: string;
  calendarDay: string;
}

@Component({
  selector: 'app-roller-soap-import-dialog',
  templateUrl: './roller-soap-import-dialog.component.html',
  styleUrls: ['./roller-soap-import-dialog.component.css']
})
export class RollerSoapImportDialogComponent {
  branchNo = '';
  terminDate = '';
  validationError = '';

  constructor(
    private dialogRef: MatDialogRef<RollerSoapImportDialogComponent, RollerSoapImportDialogResult | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: RollerSoapImportDialogData
  ) {
    this.branchNo = (data?.branchNo || '').trim();
    this.terminDate = data?.terminDate || this.todayInputValue();
  }

  get branches(): DispatchBranchOption[] {
    return this.data?.branches || [];
  }

  get soapEnvelopePreview(): string {
    const branchNo = this.branchNo.trim();
    const calendarDay = this.toCalendarDay(this.terminDate);
    if (!branchNo || !calendarDay) {
      return '';
    }

    const prepared = prepareSoapOperationRequest('getTouren', {
      branchNo,
      calendarDay,
      kvNo: '',
    });

    return prepared ? formatXml(prepared.envelope) : '';
  }

  onBranchSelected(branchId: number | null): void {
    if (branchId == null) {
      return;
    }

    const branch = this.branches.find((entry) => entry.id === branchId);
    if (branch?.short) {
      this.branchNo = branch.short.trim();
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.validationError = '';
    const branchNo = this.branchNo.trim();
    const calendarDay = this.toCalendarDay(this.terminDate);

    if (!branchNo) {
      this.validationError = 'Bitte Filialnummer eingeben (z. B. 70).';
      return;
    }

    if (!/^\d{2}$/.test(branchNo)) {
      this.validationError = 'Filiale muss eine 2-stellige Roller-Filialnummer sein (branchNo).';
      return;
    }

    if (!calendarDay) {
      this.validationError = 'Bitte ein gültiges Datum wählen.';
      return;
    }

    this.dialogRef.close({
      branchNo,
      calendarDay,
    });
  }

  private toCalendarDay(value: string): string {
    const trimmed = (value || '').trim();
    if (!trimmed) {
      return '';
    }

    if (/^\d{8}$/.test(trimmed)) {
      return trimmed;
    }

    const match = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) {
      return '';
    }

    return `${match[1]}${match[2]}${match[3]}`;
  }

  private todayInputValue(): string {
    const now = new Date();
    const month = `${now.getMonth() + 1}`.padStart(2, '0');
    const day = `${now.getDate()}`.padStart(2, '0');
    return `${now.getFullYear()}-${month}-${day}`;
  }
}
